import { render, staticRenderFns } from "./Workstyle.vue?vue&type=template&id=70db584c&scoped=true&"
import script from "./Workstyle.vue?vue&type=script&lang=ts&"
export * from "./Workstyle.vue?vue&type=script&lang=ts&"
import style0 from "./Workstyle.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Workstyle.vue?vue&type=style&index=1&id=70db584c&lang=scss&scoped=true&"
import style2 from "./Workstyle.vue?vue&type=style&index=2&id=70db584c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70db584c",
  null
  
)

export default component.exports